import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';
import { IFolder } from 'app/shared/model/folder.model';
import { getEntities as getFolders } from 'app/entities/folder/folder.reducer';
import { getEntity, updateEntity, createEntity, reset } from './to-do-item.reducer';
import { IToDoItem } from 'app/shared/model/to-do-item.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ToDoItemUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const users = useAppSelector(state => state.userManagement.users);
  const folders = useAppSelector(state => state.folder.entities);
  const toDoItemEntity = useAppSelector(state => state.toDoItem.entity);
  const loading = useAppSelector(state => state.toDoItem.loading);
  const updating = useAppSelector(state => state.toDoItem.updating);
  const updateSuccess = useAppSelector(state => state.toDoItem.updateSuccess);

  const handleClose = () => {
    props.history.push('/to-do-item' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getUsers({}));
    dispatch(getFolders({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...toDoItemEntity,
      ...values,
      folder: folders.find(it => it.id.toString() === values.folderId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...toDoItemEntity,
          userId: toDoItemEntity?.user?.id,
          folderId: toDoItemEntity?.folder?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="ensolversQaChallengeApp.toDoItem.home.createOrEditLabel" data-cy="ToDoItemCreateUpdateHeading">
            Create or edit a ToDoItem
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? <ValidatedField name="id" required readOnly id="to-do-item-id" label="ID" validate={{ required: true }} /> : null}
              <ValidatedField label="Title" id="to-do-item-title" name="title" data-cy="title" type="text" />
              <ValidatedField label="Description" id="to-do-item-description" name="description" data-cy="description" type="text" />
              <FormText>This field is required.</FormText>
              <ValidatedField id="to-do-item-folder" name="folderId" data-cy="folder" label="Folder" type="select">
                <option value="" key="0" />
                {folders
                  ? folders.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/to-do-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ToDoItemUpdate;
